import { render, staticRenderFns } from "./serviceOrderDetail.vue?vue&type=template&id=44372072&scoped=true"
import script from "./serviceOrderDetail.vue?vue&type=script&lang=js"
export * from "./serviceOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./serviceOrderDetail.vue?vue&type=style&index=0&id=44372072&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44372072",
  null
  
)

export default component.exports